module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Praise for Star Challengers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("The Star Challengers with their Commander Zota "), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("‘")]), _vm._v("boldly go into the future"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v(" to bring great science fiction adventures to their readers"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("…")]), _vm._v("what a wonderful way to expand young imaginations."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Leonard Nimoy")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("Space exploration is a great adventure that benefits all mankind. The Star Challengers books inspire young readers with that sense of adventure, introducing them to a universe of exciting possibilities."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Buzz Aldrin")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("The Star Challengers adventure stories could help to inspire a whole new generation of young women to value science and seek careers in high-tech, engineering and space exploration. These teenage Star Challengers team up in their quest to find innovative solutions to help them solve problems using real out-of-this-World science."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Dr. Sally Ride, "), _c('br'), _vm._v("Astronaut")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("In no other regime do reality and fiction seem to meet as commonly as in space. No wonder young (and old) people are inspired and excited when reading the Star Challengers series. It would be a great item to take along on one"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("s next interplanetary voyage."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Norm Augustine,"), _c('br'), _vm._v("Retired Chairman and CEO, Lockheed Martin Corporation")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("There"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("s a reason why the best science fiction takes place in space. It"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("s the only true frontier left. Kids know this. So too does the Star Challengers series. Therein is the magical recipe to ensure a future in space for the rest of us."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Neil deGrasse Tyson,"), _c('br'), _vm._v("Astrophysicist, American Museum of Natural History")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("Challenger Center continues to be a champion for the future. Young readers will readily identify with the Star Challengers characters. The future needs them, and they will respond"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("in wonderful ways."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Barbara Morgan,"), _c('br'), _vm._v("ASA"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("s First Educator Astronaut")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("I've traveled to space in the movies, but the Star Challengers books let everyone see the wonders of space in their imagination. They are packed with so much excitement, mystery and drama that I could see myself as a part of the Challenger Center mission team."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Aramis Knight, actor, "), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("Bean"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")]), _vm._v(" in "), _c('i', [_vm._v("Ender")]), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial__And__Italic"
  }, [_vm._v("’")]), _c('i', [_vm._v("s Game")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("Ad astra! To the stars! By the way of good stories! Thank you for Star Challengers, Rebecca Moesta and Kevin J. Anderson."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Clay Morgan,"), _c('br'), _vm._v("Author of "), _c('i', [_vm._v("The Boy Who Spoke Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("June Scobee"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Small_Capitals"
  }), _vm._v("Rodgers is a woman on a mission and that mission continues to expand. By nature June is an encourager and an inspiration. She has worked to bring renewed interest in science education and space travel through the Star Challengers series which will help feed young, curious minds with the possibilities that await them in the future. I can"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("t recommend these books more. Move over Avatar "), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("…")]), _vm._v(" here"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Small_Capitals"
  }), _vm._v("comes"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Small_Capitals"
  }), _vm._v("Commander Zota."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Debbie Macomber,"), _c('br'), _vm._v("#1 "), _c('i', [_vm._v("New York Times")]), _vm._v(" Bestselling Author")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("Space may be the final frontier according to Star Trek, but if our message to the next generation is to reach for the stars, then the Star Challengers series is a great place to start. Our future survival will depend upon how our young students meet the challenge of combining science, engineering, mathematics & imagination."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Lee Greenwood,"), _c('br'), _vm._v("Entertainer, Writer, Musician, Singer &"), _c('br'), _vm._v("Council Member for the National Endowment for the Arts")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Quote"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("“")]), _vm._v("What if Earth"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("s future rested on the shoulders of five ordinary teens living in present times? And what if a visitor from the future accompanies them through time and space for the adventure of their lives? I was charmed by the premise of Star Challengers, a new and innovative series geared to teen readers especially drawn to science and space technology. Never a dull moment in these fast paced books with a winsome cast of inventive kids whose ideas and solutions help make a difference for our planet. Every reader can relate to their cause and challenges. All readers will be caught up in their all too human relationships with one another and humankind from tomorrow. I found the stories infused with nail biting adventure, romance and plausible science. Skip the vampires! Don"), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("’")]), _vm._v("t miss this thought-provoking series presented by June Scobee Rodgers and the Challenger Center for Space Science Education and written by award-winning, international bestselling authors Rebecca Moesta & Kevin J. Anderson."), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_QuoteByLine"
  }, [_c('span', {
    staticClass: "C_DefaultParagraphFont__And__Arial"
  }, [_vm._v("—")]), _vm._v("Lurlene McDaniel, "), _c('br'), _vm._v("Bestselling Young-Adult Author")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0